import React, { useState, useEffect, useContext } from 'react';
import styles from './SubscriptionSearch.module.css';
import { db, auth } from '../../src/firebaseConfig';
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; 
import logo from '../assets/logo.png'; 
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';


function SubscriptionSearch() {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [subscriptions, setSubscriptions] = useState([]);
    const [viewPasswordIndex, setViewPasswordIndex] = useState(null);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [serviceFilter, setServiceFilter] = useState(''); 
    const [codeFilter, setCodeFilter] = useState(''); 
    const [showAdminPanel, setShowAdminPanel] = useState(false); // Control para el panel de login
    const navigate = useNavigate();  
    const [loading, setLoading] = useState(false);
    const { currentUser } = useContext(AuthContext);

    
    
    const serviceImages = {
        'Netflix': 'https://i.ibb.co/12fGpvt/netflix.png',
        'Disney plus': 'https://i.ibb.co/PM3rHk5/disney.png',
        'Paramount': 'https://i.ibb.co/3c8VKz7/paramount.png',
        'Prime Video': 'https://i.ibb.co/dGnWBK1/Prime.png',
        'Crunchyroll': 'https://i.ibb.co/QvsjVxW/crunchi.png',
        'Star plus': 'https://i.ibb.co/gvtkbSx/Untitled-design.png',
        'MAX': 'https://raw.githubusercontent.com/AlbeiroBurbano/ImagenesIconos/main/max.png',
        'Spotify': 'https://i.ibb.co/kSVmdPc/Spotify-1.png',
        'Canva Pro': 'https://i.ibb.co/0j7HtBV/canva.png',
        'Apple TV': 'https://i.ibb.co/WHdFPg5/Apletv.png',
        'PornHub': 'https://i.ibb.co/LxFb7TW/porn.png',
        'Vix': 'https://i.ibb.co/Th6KSVk/vix.png',
        'El profe net': 'https://i.ibb.co/bF1PBLT/net.png',
        'IPTV': 'https://i.ibb.co/S6V37w5/iptv.png',
        'Smart One IPTV': 'https://i.ibb.co/cLFbWvY/Smart.png',
        'YouTube Premium': 'https://i.ibb.co/VMQDPrf/Youtu.png',
        'Viki': 'https://i.ibb.co/0GV26V2/viki.png',
        'Chat-GPT': 'https://i.ibb.co/dWHgftY/Chatgpt-removebg-preview.png',
        'Plex': 'https://i.ibb.co/7pTV4NM/Plex-removebg-preview.png',
        'Otro': 'https://i.ibb.co/q0mVfVX/videofinal.png',
    };

        const navigateToSellerOptions = () => {
            navigate('/seller-options');
        };

        const navigateToHome = () => {
            navigate('/home');
        };

    const handleCopyAll = (sub) => {
        const content = `Código: ${sub.codigo}\nCorreo: ${sub.correo}\nContraseña: ${sub.contrasena}\nPerfil: ${sub.perfil}\nPin: ${sub.pin}\nFinalización: ${sub.endDate}\nDías restantes: ${sub.daysRemaining}`;
        navigator.clipboard.writeText(content).then(() => {
            alert('¡Toda la información ha sido copiada!');
        }).catch(err => {
            console.error('Error al copiar al portapapeles: ', err);
        });
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            alert('¡Información copiada!');
        }).catch(err => {
            console.error('Error al copiar al portapapeles: ', err);
        });
    };

const fetchSubscriptions = async () => {
    const rawInput = phoneNumber.trim();
    const inputValue = rawInput.replace(/\D/g, '');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmail = emailPattern.test(rawInput);
    
    console.log("Input original:", rawInput);
    console.log("Input limpio (números):", inputValue);
    console.log("Es email:", isEmail);
    
    if (!inputValue && !isEmail) {
        alert("Por favor, ingresa un número de celular válido o un correo electrónico.");
        return;
    }

    setLoading(true);
    try {
        let allVentasData = [];

        // Buscar en la colección "Ventas" (solo por número de teléfono)
        if (!isEmail && inputValue) {
            console.log("=== Buscando en Ventas ===");
            console.log("Buscando phoneNumber:", inputValue);
            
            const ventasRef = collection(db, "Ventas");
            const ventasQuery = query(ventasRef, where("phoneNumber", "==", inputValue));
            const ventasSnapshot = await getDocs(ventasQuery);

            console.log("Documentos encontrados en Ventas:", ventasSnapshot.size);
            
            if (!ventasSnapshot.empty) {
                const ventasData = ventasSnapshot.docs.map(doc => {
                    const data = { id: doc.id, ...doc.data(), source: 'Ventas' };
                    console.log("Documento de Ventas:", data);
                    return data;
                });
                allVentasData.push(...ventasData);
            }
        }

        // Buscar en la colección "VentasOnline"
        console.log("=== Buscando en VentasOnline ===");
        const ventasOnlineRef = collection(db, "ventasOnline");
        
        if (isEmail) {
            // Buscar por email
            console.log("Buscando correo:", rawInput);
            const ventasOnlineQuery = query(ventasOnlineRef, where("correo", "==", rawInput));
            const ventasOnlineSnapshot = await getDocs(ventasOnlineQuery);
            
            console.log("Documentos encontrados en VentasOnline por email:", ventasOnlineSnapshot.size);
            
            if (!ventasOnlineSnapshot.empty) {
                const ventasOnlineData = ventasOnlineSnapshot.docs.map(doc => {
                    const data = { id: doc.id, ...doc.data(), source: 'VentasOnline' };
                    console.log("Documento de VentasOnline (email):", data);
                    return data;
                });
                allVentasData.push(...ventasOnlineData);
            }
        } else {
            // Buscar por número de teléfono
            console.log("Buscando numero:", inputValue);
            const ventasOnlineQuery = query(ventasOnlineRef, where("numero", "==", inputValue));
            const ventasOnlineSnapshot = await getDocs(ventasOnlineQuery);
            
            console.log("Documentos encontrados en VentasOnline por número:", ventasOnlineSnapshot.size);
            
            if (!ventasOnlineSnapshot.empty) {
                const ventasOnlineData = ventasOnlineSnapshot.docs.map(doc => {
                    const data = { id: doc.id, ...doc.data(), source: 'VentasOnline' };
                    console.log("Documento de VentasOnline (número):", data);
                    return data;
                });
                allVentasData.push(...ventasOnlineData);
            }
        }

        console.log("=== Resumen de búsqueda ===");
        console.log("Total de ventas encontradas:", allVentasData.length);
        console.log("Datos de ventas:", allVentasData);

        // Si no se encontraron resultados en ninguna colección
        if (allVentasData.length === 0) {
            setSubscriptions([]);
            alert("No se encontraron ventas para este número de celular o correo electrónico.");
            return;
        }

        // Buscar las cuentas correspondientes
        console.log("=== Buscando cuentas ===");
        const cuentasRef = collection(db, "Cuentas");
        const cuentasPromises = allVentasData.map(async (venta) => {
            console.log("Buscando cuenta para código:", venta.codigo);
            const cuentasQuery = query(cuentasRef, where("codigo", "==", venta.codigo));
            const cuentasSnapshot = await getDocs(cuentasQuery);

            if (!cuentasSnapshot.empty) {
                const cuenta = cuentasSnapshot.docs[0].data();
                console.log("Cuenta encontrada para código", venta.codigo, ":", cuenta);
                
                // Mapear campos según la fuente de datos
                if (venta.source === 'Ventas') {
                    return {
                        service: venta.saleType?.trim() || "N/A",
                        codigo: venta.codigo,
                        correo: cuenta.correo,
                        contrasena: cuenta.contrasena,
                        perfil: venta.perfil || "N/A",
                        pin: venta.pin || "No disponible",
                        endDate: moment(venta.endDate).tz('America/Bogota').format('DD-MM-YYYY'),
                        daysRemaining: calculateDaysRemaining(venta.endDate),
                        source: 'Ventas'
                    };
                } else { // VentasOnline
                    // Para VentasOnline, usar fechaCorte que está en formato DD/MM/YYYY
                    let endDateFormatted = "N/A";
                    let daysRemaining = 0;
                    
                    if (venta.fechaCorte) {
                        try {
                            // fechaCorte viene en formato "04/10/2025"
                            const endMoment = moment(venta.fechaCorte, 'DD/MM/YYYY');
                            endDateFormatted = endMoment.format('DD-MM-YYYY');
                            daysRemaining = calculateDaysRemaining(endMoment.toISOString());
                        } catch (error) {
                            console.error("Error procesando fechaCorte:", venta.fechaCorte, error);
                        }
                    }
                    
                    return {
                        service: venta.plataforma?.trim() || "N/A",
                        codigo: venta.codigo,
                        correo: cuenta.correo,
                        contrasena: cuenta.contrasena,
                        perfil: venta.nombrePerfil || "N/A",
                        pin: venta.pinPerfil || "No disponible",
                        endDate: endDateFormatted,
                        daysRemaining: daysRemaining,
                        source: 'VentasOnline'
                    };
                }
            } else {
                console.log("No se encontró cuenta para código:", venta.codigo);
            }
            return null;
        });

        const resolvedCuentas = (await Promise.all(cuentasPromises)).filter(Boolean);
        console.log("Cuentas resueltas:", resolvedCuentas);

        // Filtrar suscripciones por servicio y código
        const filteredSubscriptions = resolvedCuentas.filter(sub => {
            return (
                (serviceFilter ? sub.service.toLowerCase().includes(serviceFilter.toLowerCase()) : true) &&
                (codeFilter ? sub.codigo.toLowerCase().includes(codeFilter.toLowerCase()) : true)
            );
        });

        console.log("Suscripciones filtradas:", filteredSubscriptions);
        setSubscriptions(filteredSubscriptions);
    } catch (error) {
        console.error("Error al buscar suscripciones:", error);
        alert(`Hubo un error al buscar las suscripciones: ${error.message}`);
    } finally {
        setLoading(false);
    }
};

    const revealPassword = (index) => {
        setViewPasswordIndex(index);
        setTimeout(() => setViewPasswordIndex(null), 5000); 
    };

    const calculateDaysRemaining = (endDate) => {
        const today = moment().tz('America/Bogota').startOf('day');
        const end = moment(endDate).tz('America/Bogota').startOf('day');
        return Math.max(end.diff(today, 'days'), 0);
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value.trim();
        setPhoneNumber(value);

        // Si el número es "73", mostramos el panel de login
        if (value === '73') {
            setShowAdminPanel(true);
        } else {
            setShowAdminPanel(false);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault(); // Prevenir la recarga del formulario
        if (!email || !password) {
            alert('Por favor, completa ambos campos: correo electrónico y contraseña.');
            return;
        }
        try {
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                // Verificar el rol desde Firestore
                const userDocRef = doc(db, 'Usuarios', user.uid);
                const userDocSnap = await getDoc(userDocRef);

                if (!userDocSnap.exists()) {
                alert('No se encontró información del usuario en la base de datos.');
                return;
                }

                const userData = userDocSnap.data();

                if (userData.rol !== 'admin') {
                alert('Acceso denegado: no eres administrador.');
                return;
                }

                navigate('/home');

        } catch (error) {
            console.error('Error al iniciar sesión:', error);
            alert(`Error al iniciar sesión: ${error.message}`);
        }
    };

    return (
        <div className={styles['subscription-search-wrapper']}>

            <div className={styles['subscription-search-container']}>
                <button className={styles['vendor-button']} onClick={navigateToSellerOptions}>
                    Soy Vendedor
                </button>

                <img src={logo} alt="Logo de la Empresa" className={styles['company-logo']} />
                <p className={styles['instruction-text']}>Ingresa el número de celular o email de quien compro para ver las credenciales de tus cuentas de streaming.</p>

                <div className={styles['input-with-icon']}>
                    <input
                        type="tel"
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        placeholder="Ingresa celular o Email"
                        className={styles['input']}
                    />
                </div>

                {/* Si el número es "73", mostramos el formulario de login */}
                {showAdminPanel && (
                    <form onSubmit={handleLogin} className={styles['login-form']}>
                        <input
                            type="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={styles['input']}
                        />
                        <input
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={styles['input']}
                        />
                        <button type="submit" className={styles['button']}>
                            Iniciar sesión
                        </button>
                    </form>
                )}

                <button onClick={fetchSubscriptions} className={styles['button']}>Buscar</button>
                  
                <p className={styles['footer']}>Filtros avanzados (Opcional)</p>

                <div className={styles['filter-section']}>
                    
                    <select
                        value={serviceFilter}
                        onChange={e => setServiceFilter(e.target.value)}
                        className={styles['filter-input']}
                    >
                        <option value="">Filtrar por servicio</option>
                        {Object.keys(serviceImages).map(service => (
                            <option key={service} value={service}>{service}</option>
                        ))}
                    </select>
                    <p>or</p>
                    <input 
                        type="text" 
                        placeholder="Filtrar por código" 
                        value={codeFilter} 
                        onChange={e => setCodeFilter(e.target.value)} 
                        className={styles['filter-input']} 
                    />
                </div>

                {subscriptions.length > 0 && (
                    <div className={styles['subscriptions-list']}>
                        {subscriptions.map((sub, index) => (
                            <div key={index} className={styles['subscription-card']}>
                                <img 
                                    src={serviceImages[sub.service] || serviceImages['Otro']} 
                                    alt={sub.service} 
                                    className={styles['subscription-logo']} 
                                />
                                <div className={styles['subscription-details']}>
                                    <h3>{sub.service}</h3>

                                <div className={styles['code-email-container']}>
                                    <p><strong>Código:</strong> {sub.codigo}</p>
                                   <button onClick={() => handleCopy(sub.codigo)} className="copy-button">
                                        <i className="fa fa-copy" aria-hidden="true"></i> Código
                                        </button>
                                    </div>

                                <div className={styles['password-container']}>
                                    <p><strong>Correo:</strong> {sub.correo}</p>
                                    <button onClick={() => handleCopy(sub.correo)} className="copy-button">
                                        <i className="fa fa-copy" aria-hidden="true"></i> Correo
                                        </button>
                                </div>
                                    <div className={styles['password-container']}>
                                        <strong>Contraseña:</strong>
                                        {viewPasswordIndex === index ? (
                                            <span>{sub.contrasena}</span>
                                        ) : (
                                            <span>******</span>
                                        )}
                                        <button onClick={() => revealPassword(index)} className={styles['password-toggle-button']}>
                                            <i className="fa fa-eye"></i>
                                        </button>
                                        <button onClick={() => handleCopy(sub.contrasena)} className="copy-button">
                                            <i className="fa fa-copy" aria-hidden="true"></i> Contraseña
                                            </button>
                                    </div>
                                    <p><strong>Perfil:</strong> {sub.perfil}</p>
                                    <p><strong>Pin:</strong> {sub.pin}</p>
                                    <p className={styles['end-date']}><strong>Finalización:</strong> {sub.endDate}</p>
                                    <p className={styles['days-remaining']}><strong>Días restantes:</strong> <span>{sub.daysRemaining}</span></p>
                                    <button onClick={() => handleCopyAll(sub)} className="copy-button all">
                                          <i className="fa fa-copy"></i> Copiar Todo</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <div className={styles['contact-wrapper']}>
                    <div className={styles['contact-container']}>
                        <h2>Contáctanos</h2>
                        <div className={styles['contact-buttons']}>
                            <button 
                                className={styles['contact-button']} 
                                onClick={() => window.open('https://wa.me/+573160789935', '_blank')}
                            >
                                <i className="fab fa-whatsapp"></i> Ventas
                            </button>

                            <button 
                                className={styles['contact-button']} 
                                onClick={() => window.open('https://wa.me/+573207499845', '_blank')}
                            >
                                <i className="fab fa-whatsapp"></i> Soporte
                            </button>
                        </div>
                         <button onClick={navigateToHome} className={styles['instagram-button']}>
                            <i className="fa fa-store"></i> Regresa a Home
                        </button>
                        <p className={styles['footer']}>© 2025 BearMax - Todos los derechos reservados</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionSearch;
